<div id="contentBody">
  <h2>Password Reset</h2>
  <br /><br />
  <div>Your password has been reset please <a [routerLink]="['/login']" class="subLink">Login</a> again.</div>
</div>
